import React from 'react'
import Header from '../inc/Header'

import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";


function PhotoGallery() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
       
            <br />
            <ScrollToTop smooth top="100" color="maroon" />

            <div className="petprescriptionupload">
                <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Photo Gallery</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br />
                     <div className="album py-0">
                <div className="container">
            <h1 className='mb-0'>Pet Plazaa Photo Gallery – <b style={{color:"#CC000A"}}>Celebrating Pets </b>and Their Care</h1>
            <p><small>Welcome to the <b style={{color:"#CC000A"}}>Pet Plazaa Photo Gallery</b>, where we bring our passion for pets to life through engaging and informative videos.</small></p>
            <br/>
            <p style={{color:"#CC000A"}}>Updates Coming Soon</p>
            </div>
            </div>

    </div>
  )
}

export default PhotoGallery